import RatingDots from './RatingDots'
export default RatingDots
